import React, {useState,useEffect} from 'react';
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useShoppingCart } from "../hooks/useShoppingCart";
import { getContactUrl } from '../utils/contactUrl';

// ProductCard component
const ProductCard = ({ product, prices, selectedInterval, category }) => {
    const _category = category || 'main'
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();

    const contactUrl = getContactUrl(i18n.language);

    const selectedPrice = prices.find(price => price?.recurring?.interval === selectedInterval) || (prices && prices.length && prices[0].type === 'one_time' ? prices[0] : null)

    const currency = selectedPrice?.currency?.toUpperCase() === 'EUR' ? '€' : selectedPrice?.currency?.toUpperCase()
    
    const priceValue = selectedPrice ? (selectedPrice?.unitAmount / 100 || '0.00') : '--'

    const recurrence = selectedPrice?.type === 'one_time' ? t("one_time") : selectedInterval === 'year' ? t("per_year") : selectedInterval === 'month' ? t("per_month") : ''

    const buttonLabel = product?.metadata?.purchase_method?.toLowerCase() === 'contact' ? t('contact_us') : ( _category === 'main' ? t('subscribe') : t('add_on'))

    const showQuantitySelector = product?.metadata?.allow_multiple?.toLowerCase() === 'true'

    const requiresContactInfo = product?.metadata?.require_contact_info?.toLowerCase() === 'true'
    
    const requiresCompanyInfo = product?.metadata?.require_company_info?.toLowerCase() === 'true'

    const [quantity, setQuantity] = useState(1);
    const [selected, setSelected] = useState(false);

    const handleSelect = () => {
        const isContactProduct =
            product?.metadata?.purchase_method?.toLowerCase() === 'contact';

        if (isContactProduct) {
            window.open(contactUrl, '_blank', 'noopener,noreferrer');
            return;
        }

        if (_category === 'main') {
            handleSubscriptionSelect();
        } else if (_category === 'addon') {
            handleAddonSelect();
        } else {
            console.warn('category not handled:' + _category);
        }
        setSelected(!selected);
    };

    //shoping cart
    const {
        subscription,
        selectSubscription,
        addons,
        addAddon,
        removeAddon,
        clearSubscription
    } = useShoppingCart();

    useEffect(() => {
        if (_category === "main") {
            setSelected(subscription?.id === product.id)
        } else if (_category === "addon") {
            const exists = addons.some(a => a.id === product.id)
            setSelected(exists)

            if (exists) {
                const existing = addons.find(a => a.id === product.id)
                setQuantity(existing.quantity)
            }
        }
    }, [subscription, addons, product.id, _category])

    useEffect(()=>{
        if (_category === "main" && selected){
            selectSubscription({
                id: product.id,
                crossLanguageId: product?.metadata?.cross_language_id,
                name: product.name,
                price: selectedPrice,
                quantity
            });
        }
    },[selectedInterval])


    const handleSubscriptionSelect = () => {
        if (!selected){
            selectSubscription({
                id: product.id,
                crossLanguageId: product?.metadata?.cross_language_id,
                name: product.name,
                price: selectedPrice,
                quantity
            });
            navigate("/addons");
        } else {
            clearSubscription()
        }
    };

    const handleAddonSelect = () => {
        if (!selected) {
            addAddon({
            id: product.id,
            crossLanguageId: product?.metadata?.cross_language_id,
            name: product.name,
            price: selectedPrice,
            quantity,
            requiresContactInfo,
            requiresCompanyInfo
            });
        } else {
            removeAddon(product.id);
        }
    };

    const handleAddonQuantityChange = (e) => {
        setQuantity(Number(e.target.value))
        if (selected) {
            addAddon({
                id: product.id,
                crossLanguageId: product?.metadata?.cross_language_id,
                name: product.name,
                price: selectedPrice,
                quantity: e.target.value,
                requiresContactInfo,
                requiresCompanyInfo
            });
        }
    }

    const COLOR_MAP = {
        green: '#3DA84E',
        blue: '#46B1E1'
    };

    const getColor = (color) => {
        if (!color || typeof color !== 'string') {
            return null;
        }

        const normalized = color.trim().toLowerCase();

        // Named color
        if (COLOR_MAP[normalized]) {
            return COLOR_MAP[normalized];
        }

        // Hex color validation (#RGB or #RRGGBB)
        const isHex = /^#([0-9A-F]{3}|[0-9A-F]{6})$/i.test(normalized);

        return isHex ? normalized : null;
    };

    const buttonColor = getColor(product?.metadata?.color);

    return (
        <div className="card h-100 text-center border-0 shadow-sm overflow-hidden" style={{ borderRadius: '22px', backgroundColor: 'transparent' }}>
        {product.images && product.images.length > 0 && (
            <img
                src={product.images[0]}
                className="card-img-top"
                alt={product.name}
                style={{
                    width: '100%',
                    height: 'auto',
                    objectFit: 'cover',
                    // objectPosition: 'center',
                }}
            />
        )}
        <div className="card-body d-flex flex-column" style={{backgroundColor: 'white'}}>
            {(!product.images || product.images.length <= 0) &&
            <div>
                <h5 className="card-title">{product.name}</h5>
                {product.description && (
                <p className="card-text text-muted">{product.description}</p>
                )}
            </div>}
            {product?.metadata?.purchase_method?.toLowerCase() !== 'contact' && <p className="fw-bold">{currency}{priceValue} {recurrence} {t('exclusive_vat')}</p>}

            {showQuantitySelector && (
            <div className="d-flex justify-content-center align-items-center mb-3">
                <label className="me-2">{t('quantity')}:</label>
                <input
                type="number"
                min="1"
                step="1"
                value={quantity}
                onChange={handleAddonQuantityChange}
                style={{ width: '4rem', textAlign: 'center' }}
                className="form-control form-control-sm"
                />
            </div>
            )}

            {selected ?
                <button className={buttonColor ? "btn mt-auto" : "btn btn-outline-primary mt-auto"} style={buttonColor? {borderColor: buttonColor, color: buttonColor} : {}} onClick={handleSelect}>{t('remove')}</button>:
                <button className={buttonColor ? "btn mt-auto" : "btn btn-primary mt-auto"} style={buttonColor? {backgroundColor: buttonColor, color: 'white'} : {}} onClick={handleSelect}>{buttonLabel}</button>
            }
        </div>
        </div>
    );
};

export default ProductCard;